import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { withRouter } from 'react-router'

import { Header as LayoutHeader, Content, Tabs, NavLink, Link } from 'features/layout/components/header'
import { layout } from 'assets/styles/mixins.js'
import { Icon, RedDot } from 'gipsy-ui'
import { utils, styles, translations } from 'gipsy-misc'

import { elementHasNotifications } from 'features/notifications/utils'

const mapStateToProps = state => ({
  notifications: state.notifications.list
})

class TodolistHeader extends PureComponent {
  isTodolist = () => {
    const { location } = this.props
    return location.pathname === '/' || location.pathname === '/archive' || location.pathname === '/index.html'
  }

  isArchive = () => {
    const { location } = this.props
    return location.pathname === '/archive'
  }

  isCalendar = () => {
    const { location } = this.props
    return location.pathname.includes('/calendar')
  }

  isCalendarDayActive = () => {
    const { location } = this.props
    return location.pathname === '/calendar'
  }

  isCalendarWeekActive = () => {
    const { location } = this.props
    return location.pathname === '/calendar/week'
  }

  isFocusView = () => {
    const { location } = this.props
    return location.pathname.includes('/focusview')
  }

  render() {
    const { notifications } = this.props

    return (
      <Header className="header">
        <Content>
          <Tabs className="tabs">
            <Link to="/" className={this.isTodolist() && 'active'}>
              <Icon
                icon="List"
                size={16}
                fill={this.isTodolist() ? styles.colors.primaryColor : styles.colors.darkGrey}
              />
            </Link>
            <Link to="/calendar" className={this.isCalendar() && 'active'}>
              <Icon
                icon="Calendar"
                size={16}
                fill={this.isCalendar() ? styles.colors.primaryColor : styles.colors.darkGrey}
              />
            </Link>
            <Link to="/focusview" className={this.isFocusView() && 'active'}>
              <Icon
                icon="Bullseye"
                size={16}
                fill={this.isFocusView() ? styles.colors.primaryColor : styles.colors.darkGrey}
              />
            </Link>
          </Tabs>
          {this.isCalendar() && (
            <Tabs className="tabs">
              <NavLink exact to="/calendar">
                <span>{utils.string.capitalize(translations.general.day.singular)}</span>
              </NavLink>
              <NavLink exact to="/calendar/week" params={{ view: 'week' }}>
                <span>{utils.string.capitalize(translations.general.week)}</span>
              </NavLink>
              {/*<Link to="/calendar/month" params={{ view: 'month' }}>
                <span>Month</span>
              </Link>*/}
            </Tabs>
          )}
          {this.isTodolist() && (
            <Tabs className="tabs">
              <NavLink to="/" exact activeClassName="active">
                <span>Tasks</span>
                {elementHasNotifications(notifications, `todolist:tasks`) ? <AbsoluteRedDot /> : ''}
              </NavLink>
              <NavLink to="/archive" exact activeClassName="active">
                <span>Archive</span>
                {elementHasNotifications(notifications, `todolist:archive`) ? <AbsoluteRedDot /> : ''}
              </NavLink>
            </Tabs>
          )}
        </Content>
      </Header>
    )
  }
}

const Header = styled(LayoutHeader)`
  ${layout};
`

const AbsoluteRedDot = styled(RedDot)`
  position: absolute;
  top: 12px;
  right: 0px;
`

export default withRouter(
  connect(
    mapStateToProps,
    null,
    null,
    {
      pure: true
    }
  )(TodolistHeader)
)



// WEBPACK FOOTER //
// ./src/features/todolist/components/header/index.js